import { render, staticRenderFns } from "./ProviderStatementNonAuth.vue?vue&type=template&id=b4d11ed8&scoped=true&"
import script from "./ProviderStatementNonAuth.vue?vue&type=script&lang=js&"
export * from "./ProviderStatementNonAuth.vue?vue&type=script&lang=js&"
import style0 from "./ProviderStatementNonAuth.vue?vue&type=style&index=0&id=b4d11ed8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d11ed8",
  null
  
)

export default component.exports